module.exports = __webpack_public_path__ + "img/8-ton-crane-hazchem-truck.0fe80d1c.jpg";